'use strict';
 /**
 * @author Maxim Seredkin
 */
export default ['$resource',
    function ($resource) {
        return $resource('api/orgs/:orgId', null, {
            get: {method: 'GET'},
            create: {method: 'POST'},
            update: {method: 'PUT'},
            remove: {method: 'DELETE'},
            okveds: {url: 'api/orgs/:orgId/okveds', method: 'GET'},
            staffs: {url: 'api/orgs/:orgId/staffs', method: 'GET'},
            exists: {url: 'api/orgs/exists', method: 'GET'},
            types: {url: 'api/orgs/type', method: 'GET'}
        });
    }];